export default window.location.pathname.split('/')[1]
